import { Navigate, Route, Routes, useParams } from "react-router-dom";
import ChatList from "@/components/ChatList";
import Layout from "@/components/Layout";
import Admin from "@/pages/admin/Admin";
import AgentsPage from "@/pages/agents/Agents";
import FolderBrowser from "@/pages/FolderBrowser";
import SpaceHome from "@/pages/SpaceHome";
import Spaces from "@/pages/Spaces";
import ChatPage from "@/pages/ChatPage";
import ConnectCompanion from "@/pages/ConnectCompanion";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Settings from "@/pages/Settings";
import TasksPage from "@/pages/tasks/Tasks";
import TempChatPage from "@/pages/TempChatPage";

/** Links from before folders became spaces. */
function OldFolder() {
  const { id } = useParams();
  return <Navigate to={`/spaces/${id}/files${window.location.search}`} replace />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/connect/companion" element={<ConnectCompanion />} />
      <Route element={<Layout sidebar={<ChatList />} />}>
        <Route index element={<Home />} />
        <Route path="c/:id" element={<ChatPage />} />
        <Route path="temp/:id" element={<TempChatPage />} />
        <Route path="spaces" element={<Spaces />} />
        <Route path="spaces/:id" element={<SpaceHome />} />
        <Route path="spaces/:id/files" element={<FolderBrowser />} />
        <Route path="folders" element={<Navigate to="/spaces" replace />} />
        <Route path="folders/:id" element={<OldFolder />} />
        <Route path="tasks/*" element={<TasksPage />} />
        <Route path="agents/*" element={<AgentsPage />} />
        <Route path="settings/*" element={<Settings />} />
        <Route path="admin/*" element={<Admin />} />
      </Route>
    </Routes>
  );
}
